<script>
import debounce from 'lodash/debounce';

export default {
  name: 'RexTableSortField',
  props: {
    width: { type: String, default: '1rem' },
    height: { type: String, default: '1rem' },
    name: { type: String, default: '' },
    isAsc: { type: Boolean, default: false },
    isActiveField: { type: Boolean, default: true }
  },
  methods: {
    debouncedToggleSorting: debounce(function() {
      this.$emit('toggleSort');
    }, 300)
  }
};
</script>

<template>
  <div class="sort-table-header" @click="debouncedToggleSorting">
    <slot name="sorting-header">
      <div>{{ name }}</div>
    </slot>
    <div class="sort-table-header-icon">
      <BaseIcon
        name="sortAsc"
        class="base-icon sort-asc"
        :class="isAsc && isActiveField && 'sort-icon'"
        :width="width"
        :height="height"
      />
      <BaseIcon
        name="sortDes"
        class="base-icon"
        :class="!isAsc && isActiveField && 'sort-icon'"
        :width="width"
        :height="height"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.sort-table-header {
  @include flex-center-vert;
  cursor: pointer;
}
.base-icon {
  @include svg-fill-pointer($color-brand-accent);
  opacity: 0.5;
}
.sort-asc {
  margin-bottom: -0.9em;
}
.sort-icon {
  opacity: 1;
}
.sort-table-header-icon {
  @include flex-column;
  margin-left: 0.5rem;
  margin-top: 0.6rem;
}
</style>
